import { useState, useEffect } from 'react';

import TopNavBar from '../components/TopNavBar';
import SideNavBar from '../components/SideNavBar';

import Refreshing from '../components/Refreshing';

import * as apiComms from '../apiComms';

import * as dayjs from 'dayjs'

// Components
import BusinessLocation from '../components/BusinessLocation';
import useIsMobile, { DESKTOP_CONTENT_MARGIN_LEFT, MOBILE_CONTENT_MARGIN_LEFT } from '../hooks/useIsMobile';

import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { IoMdAddCircleOutline } from "react-icons/io";


const BusinessLocations = (props) => {

  const [showInfoBox, setShowInfoBox] = useState(true);
  const [displayBusinessLocations, setDisplayBusinessLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAddBusinessLocationVisible, setIsAddBusinessLocationVisible] = useState(false);
  const isMobile = useIsMobile();
  
  useEffect(() => {
    refreshBusinessLocations();
  }, []);

  const refreshBusinessLocations = async () => {
    const FUNCTION = 'refreshBusinessLocations';

    setIsLoading(true);

    const businessLocationsRes = await apiComms.getAllBusinessLocations();

    if (businessLocationsRes.isErr) {
      alert('Sorry an error occured: '+businessLocationsRes.errMsg);
    }
    else {
      let businessLocations = businessLocationsRes.response.locations;
      //_enrichCoupons(coupons);
      setDisplayBusinessLocations(businessLocations);
    }
    setIsLoading(false);
  };

  return (
    <>
      <TopNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
      <SideNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
      <div style={{ marginLeft: isMobile ? MOBILE_CONTENT_MARGIN_LEFT : DESKTOP_CONTENT_MARGIN_LEFT, marginRight : 10, marginTop : 0, paddingTop : 45 }}>
        <h1 style={{ fontSize: 18, fontWeight : 'bold', paddingTop : 20, marginLeft : 10 }}>Business > Business Locations</h1>

        { showInfoBox ? (
          <div style={{ marginTop : 20 }} className="alert alert-primary lert-dismissible fade show" role="alert">
            <h4 className="alert-heading">About Business Locations</h4>
            <p>Business locations are synced from Google Maps, To add locations, or change any location details, update your location via Google Business Profile (formally known as Google May Business).</p>
            <button style={{ position : 'absolute', top : 10, right : 10 }} type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={ () => { setShowInfoBox(false); }} onPress={ () => { setShowInfoBox(false); }}></button>
          </div>
        ) : null }

        { isLoading ? (
          <Refreshing message='Loading Business Locations...' />
        ) : null }
      
        { !isLoading ? (
          <>
            <div style={{ display : 'flex', flexWrap : 'wrap', height : '100%', width : '100%', flexDirection : 'row', justifyContent : 'flex-start', alignItems : 'center' }}>
              { displayBusinessLocations.map((businessLocation, i) => {
                return (
                  <>
                    <BusinessLocation location={ businessLocation } />
                    <div style={{ height : 10 }}>&nbsp;</div>
                  </>
                )
              })}
            </div>

            {/*
            <div style={{ margin : 10, borderRadius: 10, overflow : 'hidden', cursor : 'pointer' }} onClick = { () => { setIsAddBusinessLocationVisible(true); }} >
              <div style={{ aspectRatio : '1/1', flex: '0 1 256px', backgroundColor : '#eee', margin : 0, width : 256, height : 256, alignItems : 'center', justifyContent : 'center' }}><MdOutlineAddPhotoAlternate style={{ width : '100%', height : '100%', padding : 40, color : '#039be5' }}/></div>  
              <div style={{ height : 40, backgroundColor : '#8d949e', paddingLeft: 10, paddingRight : 10, display : 'flex', alignItems : 'center', justifyContent : 'space-between', width : '100%' }}>
                <div style={{ color : 'white', fontSize: 18, fontWeight : 'bold' }}>Add New</div>
                <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>                   
                  <div><IoMdAddCircleOutline style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
                </div>
              </div>
            </div>
            */}

          </>
        ) : null }

        </div>

    </>
  );

};

export default BusinessLocations;

        

          


    
  
